// extracted by mini-css-extract-plugin
export var option = "_av-0";
export var optionCard = "_av-f";
export var optionContent = "_av-g";
export var optionIcon = "_av-i";
export var optionIconBox = "_av-h";
export var optionLabel = "_av-j";
export var optionPill = "_av-m";
export var optionPillBadge = "_av-p";
export var optionPillIcon = "_av-n";
export var optionPillLabel = "_av-o";
export var optionRadio = "_av-k";
export var optionRadioInner = "_av-l";
export var optionReveal = "_av-2";
export var optionRevealDelay0 = "_av-3";
export var optionRevealDelay1 = "_av-4";
export var optionRevealDelay10 = "_av-d";
export var optionRevealDelay11 = "_av-e";
export var optionRevealDelay2 = "_av-5";
export var optionRevealDelay3 = "_av-6";
export var optionRevealDelay4 = "_av-7";
export var optionRevealDelay5 = "_av-8";
export var optionRevealDelay6 = "_av-9";
export var optionRevealDelay7 = "_av-a";
export var optionRevealDelay8 = "_av-b";
export var optionRevealDelay9 = "_av-c";
export var optionSelected = "_av-1";